import { AUCountryUIConfig } from './countries/AUCountryUIConfig';
import { CACountryUIConfig } from './countries/CACountryUIConfig';
import { DECountryUIConfig } from './countries/DECountryUIConfig';
import { GBCountryUIConfig } from './countries/GBCountryUIConfig';
import { NZCountryUIConfig } from './countries/NZCountryUIConfig';
import { USCountryUIConfig } from './countries/USCountryUIConfig';
import { AU, CA, DE, GB, NZ, US } from '../../../constants/country-codes';

import type { AvailableCountryCodes, CountryConfig } from '../types';

export const COUNTRY_CONFIGS_UI: Partial<Record<AvailableCountryCodes, CountryConfig>> = {
  [DE]: DECountryUIConfig,
  [GB]: GBCountryUIConfig,
  [US]: USCountryUIConfig,
  [CA]: CACountryUIConfig,
  [AU]: AUCountryUIConfig,
  [NZ]: NZCountryUIConfig,
};

export const getCountryUIConfig = (countryCode: AvailableCountryCodes): CountryConfig => {
  return COUNTRY_CONFIGS_UI[countryCode] || [];
};
